var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('select',{staticClass:"form-control",attrs:{"id":_vm.id,"name":_vm.name,"multiple":_vm.multiple},domProps:{"value":_vm.value}},[(!_vm.value)?_c('option'):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }